import { render, staticRenderFns } from "./EditableNumericCell.vue?vue&type=template&id=0bf8c1d4&scoped=true&"
import script from "./EditableNumericCell.vue?vue&type=script&lang=js&"
export * from "./EditableNumericCell.vue?vue&type=script&lang=js&"
import style0 from "./EditableNumericCell.vue?vue&type=style&index=0&id=0bf8c1d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf8c1d4",
  null
  
)

export default component.exports